import { render, staticRenderFns } from "./clear.vue?vue&type=template&id=57ff3c2f&scoped=true&"
import script from "./clear.vue?vue&type=script&lang=js&"
export * from "./clear.vue?vue&type=script&lang=js&"
import style0 from "./clear.vue?vue&type=style&index=0&id=57ff3c2f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ff3c2f",
  null
  
)

export default component.exports